<template>
    <dash
        icon="fa fa-dollar"
        titulo="PAGAMENTOS CONSULTORIAS"
        subTitulo="APP SEBRAE"
        @click.native="
            $router.push({
                name: 'AppSebrae_Consultorias_Fornecedor_Pagamentos'
            })
        "
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
